import { Component, OnInit } from '@angular/core';
import { TokenService } from 'src/app/services/common/token.service';
import { SdoService } from 'src/app/services/sdo.service';
import { MessageService, PrimeNGConfig } from 'primeng/api';
import { ActivatedRoute, Router } from '@angular/router';
import { CryptoJsService } from 'src/app/services/crypto-js.service';

@Component({
  selector: 'app-view-form',
  templateUrl: './view-form.component.html',
  styleUrls: ['./view-form.component.scss']
})
export class ViewFormComponent implements OnInit {
  dataOfPhysicalVerMIDone: any = [];
  autoId: any;
  items: any[];

  constructor(private tokenService: TokenService, private messageService: MessageService,
    private sdoService: SdoService, private route: ActivatedRoute, private router: Router, private cryptoJsService: CryptoJsService) { }

  ngOnInit(): void {
    this.getDataOfPhysicalVerMIDone(this.autoId);
    let autoId = 2;
    // let sessionToken = this.cryptoJsService.DecryptToken(sessionStorage.getItem('token'));

    // this.sdoService.getAppForPhysicalVerMIDone(autoId)
    //   .pipe()
    //   .subscribe({
    //     next: (data) => {
    //       this.dataOfPhysicalVerMIDone = data;
    //     },
    //     error: () => {
    //       this.messageService.add({ severity: 'error', summary: 'Error Message'});
    //     }
    //  });

  }


  totalPrice = 0;
  totalSubsidyAmount = 0;
  totalFarmerShare = 0;
  getDataOfPhysicalVerMIDone(autoId) {
    this.route.queryParams
      .subscribe(params => {
        this.autoId = this.cryptoJsService.DecryptData(params?.autoId);
        if (this.autoId) {
          this.sdoService.getDataOfPhysicalVerMIDone(this.autoId).pipe()
            .subscribe({
              next: (data: any) => {
                this.dataOfPhysicalVerMIDone = data;
                let sumOfPrice = 0;
                let sumOfSubsidy = 0;
                let sumOfFarmerShare = 0;
                this.dataOfPhysicalVerMIDone.map((row: any) => {
                  sumOfSubsidy += row.SubsidyToFarmerAmount;
                  sumOfFarmerShare += row.FarmerShareAmount;
                });
                this.dataOfPhysicalVerMIDone?.listDataForPhysicalVer.map((row: any) => {
                  sumOfPrice += row.Price;
                })
                this.totalPrice = sumOfPrice;
                this.totalSubsidyAmount = sumOfSubsidy;
                this.totalFarmerShare = sumOfFarmerShare;
              },
              error: () => {
                this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Data error! data not loaded.' });
              }
            });

        } else {
          this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Data error! AutoID cant be empty' });
          return;
        }
      }
      );


  }

}
